export const jobObjectTypesEnum = {
  asset_position: 'asset_position',
  scheme: 'scheme',
} as const

export type JobObjectTypesEnum = (typeof jobObjectTypesEnum)[keyof typeof jobObjectTypesEnum]

export type JobObjectTypes = JobObjectTypesEnum